(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["land-youtube-auto-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function escapeHTML(value) {
      return String(value).replace(/[&<>"']/g, function (character) {
        return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#039;'
        }[character];
      });
    }

    function initializeCarousel(section) {
      if (section.hasAttribute('data-initialized')) return;
      section.setAttribute('data-initialized', 'true');

      var apiKey = section.getAttribute('data-api-key');
      var playlistID = section.getAttribute('data-playlist-id');
      var videoCount =
        parseInt(section.getAttribute('data-video-count'), 10) || 12;
      var status = section.querySelector('.land-youtube-feed__status');
      var track = section.querySelector('.land-youtube-feed__track');
      var previous = section.querySelector('.land-youtube-feed__previous');
      var next = section.querySelector('.land-youtube-feed__next');

      if (!apiKey) {
        status.textContent =
          'Add the restricted YouTube API key in this section’s settings.';
        return;
      }

      var requestURL =
        'https://www.googleapis.com/youtube/v3/playlistItems' +
        '?part=snippet' +
        '&maxResults=' +
        videoCount +
        '&playlistId=' +
        encodeURIComponent(playlistID) +
        '&key=' +
        encodeURIComponent(apiKey);

      fetch(requestURL)
        .then(function (response) {
          if (!response.ok) {
            throw new Error('YouTube request failed');
          }

          return response.json();
        })
        .then(function (data) {
          var videos = (data.items || []).filter(function (item) {
            var snippet = item.snippet || {};
            var title = snippet.title || '';

            return (
              snippet.resourceId &&
              snippet.resourceId.videoId &&
              title !== 'Private video' &&
              title !== 'Deleted video'
            );
          });

          if (!videos.length) {
            throw new Error('No public videos were returned');
          }

          track.innerHTML = videos
            .map(function (item) {
              var videoID = item.snippet.resourceId.videoId;
              var safeVideoID = escapeHTML(videoID);
              var title = escapeHTML(item.snippet.title);

              return (
                '<article class="land-youtube-feed__card">' +
                '<div class="land-youtube-feed__player">' +
                '<button class="land-youtube-feed__thumbnail" ' +
                'type="button" ' +
                'data-video-id="' +
                safeVideoID +
                '" ' +
                'aria-label="Play ' +
                title +
                '">' +
                '<img ' +
                'src="https://i.ytimg.com/vi/' +
                encodeURIComponent(videoID) +
                '/hqdefault.jpg" ' +
                'alt="' +
                title +
                '" ' +
                'loading="lazy">' +
                '<span class="land-youtube-feed__play" aria-hidden="true">▶</span>' +
                '</button>' +
                '</div>' +
                '<div class="land-youtube-feed__content">' +
                '<h3 class="land-youtube-feed__card-title">' +
                title +
                '</h3>' +
                '</div>' +
                '</article>'
              );
            })
            .join('');

          status.hidden = true;
          track.hidden = false;

          track
            .querySelectorAll('.land-youtube-feed__thumbnail')
            .forEach(function (button) {
              button.addEventListener('click', function () {
                var videoID = button.getAttribute('data-video-id');
                var iframe = document.createElement('iframe');

                iframe.src =
                  'https://www.youtube-nocookie.com/embed/' +
                  encodeURIComponent(videoID) +
                  '?autoplay=1&rel=0';
                iframe.title = button.getAttribute('aria-label');
                iframe.allow =
                  'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
                iframe.allowFullscreen = true;

                button.replaceWith(iframe);
              });
            });
        })
        .catch(function () {
          status.textContent =
            'The videos could not load. Check the API key, API restriction and allowed website addresses.';
        });

      function scrollCarousel(direction) {
        var card = track.querySelector('.land-youtube-feed__card');
        var gap = window.innerWidth <= 600 ? 14 : 20;
        var distance = card ? card.offsetWidth + gap : track.clientWidth;

        track.scrollBy({
          left: direction * distance,
          behavior: 'smooth'
        });
      }

      previous.addEventListener('click', function () {
        scrollCarousel(-1);
      });

      next.addEventListener('click', function () {
        scrollCarousel(1);
      });
    }

    function initializeAllCarousels() {
      document
        .querySelectorAll('[data-land-youtube-feed]')
        .forEach(initializeCarousel);
    }

    initializeAllCarousels();
    document.addEventListener(
      'shopify:section:load',
      initializeAllCarousels
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
